import { all } from 'redux-saga/effects'
import mainSaga from './main'
import filterSaga from './filter'
import searchSaga from './search'
import calendarSaga from './calendar'

export default function* contentDeskSaga() {
  yield all([
    mainSaga(),
    filterSaga(),
    searchSaga(),
    calendarSaga()
  ])
}
